/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const numericRangeResponseDtoSchema = z.object({
    "min": z.optional(z.number()),
"max": z.optional(z.number())
    })